module.exports = __webpack_public_path__ + "img/icon-map.f4dc912d.png";